export default __webpack_public_path__ + "static/casestudy_4-df8bff0150eeb6fbb8a55751f4e2a169.png";